import Clickable from '/components/Clickable';
import PropTypes from 'prop-types';

import { getPackCartData } from '/services/static/packs/pack-cart-data';
import { useCartStore } from '/state/cart-context';
import { useGlobalStore } from '/state/global-context';

import { DEFAULT_ADD_TO_CART_TEXT, getAddToCartStatus } from '/services/static/packs/utils';

import { useEffect, useState } from 'react';

const AddToCart = ({ builderConfig, packConfig, parentProduct }) => {
	const [addToCartText, setAddToCartText] = useState(DEFAULT_ADD_TO_CART_TEXT);
	const [isDisabled, setIsDisabled] = useState(true);
	const [isLoading, setIsLoading] = useState(false);

	const cart = useCartStore();
	const globalStore = useGlobalStore();

	useEffect(() => {
		const addToCartStatus = getAddToCartStatus(builderConfig, packConfig);
		setIsDisabled(addToCartStatus.disabled);
		setAddToCartText(addToCartStatus.buttonText);
	}, [builderConfig, packConfig.selectedProducts, packConfig.selectedExtras]);

	const handleLoadingComplete = () => {
		setTimeout(() => {
			setIsLoading(false);
		}, 2000);
	};

	const addSelectedProductsToCart = async () => {
		setIsLoading(true);
		const isSitewidePack = globalStore.getSitewidePack();
		const cartData = getPackCartData(builderConfig, packConfig, parentProduct, isSitewidePack);

		if (!cartData?.lines) {
			setIsLoading(false);
			return;
		}

		// add the items to the cart
		await cart
			.addItems({
				analytics: cartData.analytics || [],
				analyticsProduct: cartData.analyticsProduct || {},
				lines: cartData.lines || [],
				error: () => {
					handleLoadingComplete();
				},
				success: () => {
					handleLoadingComplete();
				},
			})
			.catch(() => {
				handleLoadingComplete();
			});
	};

	return (
		<div className="bg-v2-off-white sticky bottom-0 z-20 md:relative md:bottom-auto">
			<Clickable
				className="w-full"
				variant="filled"
				disabled={isDisabled || isLoading}
				onClick={() => {
					void addSelectedProductsToCart();
				}}>
				{addToCartText}
			</Clickable>
		</div>
	);
};

AddToCart.propTypes = {
	builderConfig: PropTypes.object,
	packConfig: PropTypes.object,
	parentProduct: PropTypes.object,
	setAddToCartLoading: PropTypes.func,
};

export default AddToCart;
